var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconMenuCall(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    color: "currentColor",
    height: 25,
    viewBox: "0 0 25 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M20.5 15.634C19.3 15.634 18 15.434 16.9 15.034H16.6C16.3 15.034 16.1 15.134 15.9 15.334L13.7 17.534C10.9 16.034 8.5 13.734 7.1 10.934L9.3 8.73403C9.6 8.43403 9.7 8.03403 9.5 7.73403C9.2 6.63403 9 5.33403 9 4.13403C9 3.63403 8.5 3.13403 8 3.13403H4.5C4 3.13403 3.5 3.63403 3.5 4.13403C3.5 13.534 11.1 21.134 20.5 21.134C21 21.134 21.5 20.634 21.5 20.134V16.634C21.5 16.134 21 15.634 20.5 15.634ZM5.5 5.13403H7C7.1 6.03403 7.3 6.93403 7.5 7.73403L6.3 8.93403C5.9 7.73403 5.6 6.43403 5.5 5.13403ZM19.5 19.134C18.2 19.034 16.9 18.734 15.7 18.334L16.9 17.134C17.7 17.334 18.6 17.534 19.5 17.534V19.134Z",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconMenuCall);
export default __webpack_public_path__ + "static/media/icon_menu_call.9409ce055174c73d23889cd1e4213e3b.svg";
export { ForwardRef as ReactComponent };